<template>
  <iColumn
    gap="standard"
    width="fill"
    wrap="nowrap"
    data-test="save-chooser-body"
  >
    <iRow
      gap="small"
      width="fill"
      align="between"
      vertical-align="middle"
      wrap="nowrap"
      data-test="save-chooser-all-posts"
    >
      <iRow
        gap="small"
        width="hug"
        vertical-align="middle"
        wrap="nowrap"
      >
        <iIcon
          :icon="ICONS.saved"
          :name="ICONS.saved"
          size="standard"
          disable-hover
        />
        <iText font-weight="dark">
          {{ allPostsName }}
        </iText>
      </iRow>
      <iText variant="subtle">
        Saved
      </iText>
    </iRow>
    <iDivider />
    <iColumn gap="small" width="fill" wrap="nowrap">
      <iText font-weight="dark" font-size="small">
        Collections
      </iText>
      <iLoadingSpinner v-if="chooser.loading" size="small" />
      <iText
        v-else-if="!chooserCollections.named.length"
        variant="subtle"
        font-size="small"
        data-test="save-chooser-no-collections"
      >
        Add it to a collection of your own to find it faster.
      </iText>
      <template v-else>
        <iCheckbox
          v-for="collection in chooserCollections.named"
          :key="collection.collectionId"
          :model-value="collection.collectionItemId > 0"
          :label="collection.name"
          :disabled="chooser.busyCollectionId === collection.collectionId"
          data-test="save-chooser-collection"
          :data-collection-id="collection.collectionId"
          @change="toggleInCollection(collection)"
        />
      </template>
    </iColumn>
    <iRow
      gap="small"
      width="fill"
      vertical-align="middle"
      wrap="nowrap"
    >
      <iTextInput
        v-model="newName"
        placeholder="New collection"
        width="fill"
        size="small"
        data-test="save-chooser-new-name"
        @enter="create"
      />
      <iButton
        variant="secondary"
        size="small"
        :is-loading="chooser.busyCollectionId === CREATING"
        data-test="save-chooser-create"
        @click="create"
      >
        Create
      </iButton>
    </iRow>
    <iText
      v-if="chooser.error"
      variant="error"
      font-size="small"
      data-test="save-chooser-error"
    >
      {{ chooser.error }}
    </iText>
  </iColumn>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useSavedPostsStore } from "%/dynamic-component-editor/stores/saved-posts-store";
import { ENGAGEMENT_ICONS } from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";

const CREATING = -1;
const DEFAULT_ALL_POSTS_NAME = "All posts";

export default {
  name: "SaveToCollectionChooserBody",
  data() {
    return { newName: "", CREATING, ICONS: ENGAGEMENT_ICONS };
  },
  computed: {
    ...mapState(useSavedPostsStore, ["chooser", "chooserCollections"]),
    allPostsName() {
      return this.chooserCollections.allPosts?.name || DEFAULT_ALL_POSTS_NAME;
    },
  },
  methods: {
    ...mapActions(useSavedPostsStore, ["toggleInCollection", "createCollection"]),
    create() {
      this.createCollection(this.newName).then(created => {
        if (created) {
          this.newName = "";
        }
      });
    },
  },
};
</script>
